define('views/components/distributor_product/distributor_product_list',['require','views/base/list_view','views/components/distributor_product/distributor_product','text!templates/components/distributor_product/distributor_product_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/distributor_product/distributor_product');

    var temp = require("text!templates/components/distributor_product/distributor_product_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

